module.exports = __webpack_public_path__ + "static/media/creative.400d6bfc.webp";